module.exports = __webpack_public_path__ + "img/24.ef003912.png";